import { useState } from "react";
import { portalAuthErrorMessage } from "../auth/errors";
import { loginWithPasskey } from "../auth/passkeys";
import type { PortalMeDto } from "../model";
import { StatusBanner } from "./StatusBanner";
export function LoginView({ onAuthenticated }: { onAuthenticated: (actor: PortalMeDto) => void }) {
	const [error, setError] = useState("");
	const [submitting, setSubmitting] = useState(false);
	async function login() {
		if (submitting) return;
		setSubmitting(true);
		setError("");
		try {
			onAuthenticated(await loginWithPasskey());
		} catch (reason) {
			setError(portalAuthErrorMessage(reason, "Passkey sign-in could not be completed. Try again."));
		} finally {
			setSubmitting(false);
		}
	}
	return (
		<section className="auth-card" aria-labelledby="login-heading">
			<p className="eyebrow">PRIVATE PROJECT ACCESS</p>
			<h1 id="login-heading" tabIndex={-1}>
				Continue with your passkey
			</h1>
			<p>Your projects, decisions, and conversations stay in one shared record.</p>
			{error && <StatusBanner kind="error">{error}</StatusBanner>}
			<button type="button" disabled={submitting} onClick={login}>
				{submitting ? "Checking passkey…" : "Use a passkey"}
			</button>
			<a href="/claim">I have an invitation</a>
		</section>
	);
}
